import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CardMedia from '@mui/material/CardMedia';
import { useTheme } from '@mui/material/styles';
import InformationStack from '../../components/stacks/InformationStack';
import { buildCdnUrl, getCdnUrl, useGetCountry } from '../../helpers';
import { Marquee, ScrollAppear } from '../../components/animations';
import {
  ENTITIES_LIST_CLASS_NAME,
  STACK_CENTER,
  STACK_CENTER_COLUMN_DIRECTION,
  INFORMATION_STACK_WITH_BORDER,
} from '../../constants/mui-components';
import {
  heroStackContainer,
  titleTypography,
  subtitleTypography,
  heroButtonsStack,
  imageStack,
  entitiesContainer,
  entitiesImagesListItem,
  entitiesSubContainer,
} from './styles/hero.styles';
import { GradientDivider } from '../../components/lines';
import heroData from '../../constants/home/hero';
import RegisterButton from '../../components/buttons/RegisterButton';
import CountryEnum from '../../constants/country-enum';

function Hero() {
  const theme = useTheme();
  const country = useGetCountry();
  const imageSrc = country === CountryEnum.CHILE
    ? heroData.chileImageSrc : heroData.mexicoImageSrc;
  const heroImageUrl = buildCdnUrl(imageSrc, {
    width: 1200,
    format: 'webp',
    quality: 80,
  });
  const entitiesMapper = {
    Chile: heroData.entitiesImagesSrc,
    Mexico: heroData.entitiesImagesSrc.filter((image) => image.alt !== 'afys'),
  };
  return (
    <Stack
      className={STACK_CENTER_COLUMN_DIRECTION}
      sx={heroStackContainer(theme)}
    >
      <Stack className={STACK_CENTER_COLUMN_DIRECTION} gap="2rem">
        <InformationStack
          className={INFORMATION_STACK_WITH_BORDER}
          text={heroData.stackText}
          backgroundColor={theme.palette.neutral.A700}
          textColor={theme.palette.common.white}
          variant="info_stack"
          fontWeight={800}
          sx={{ display: { xs: 'none', phone: 'flex' } }}
        />
        <Stack className={STACK_CENTER} gap="1rem">
          <Typography component="h1" variant="title_1" sx={titleTypography}>
            {heroData.titleText}
          </Typography>
          <Typography variant="medium_1" sx={subtitleTypography}>
            {heroData.subtitleText}
          </Typography>
        </Stack>
        <Stack sx={heroButtonsStack}>
          <RegisterButton text="Anticipar mis facturas" />
        </Stack>
      </Stack>
      <ScrollAppear>
        <Stack sx={imageStack}>
          <CardMedia
            component="img"
            image={heroImageUrl}
            alt="hero_image"
            style={{ objectFit: 'contain', width: '100%' }}
          />
        </Stack>
      </ScrollAppear>
      <Stack className={STACK_CENTER_COLUMN_DIRECTION} sx={entitiesContainer}>
        <GradientDivider color="rgba(230, 46, 102, 0.6)" maxWidth="80rem" width="100%" />
        <Stack
          className={STACK_CENTER_COLUMN_DIRECTION}
          sx={entitiesSubContainer}
        >
          <Typography variant="large_1" color={theme.palette.common.white} align="center">
            {heroData.entitiesText}
          </Typography>
          <Marquee direction="left" speed={20} distance="100%">
            <MenuList className={ENTITIES_LIST_CLASS_NAME}>
              {entitiesMapper[country].map((entity, index) => {
                const isLastImage = index === entitiesMapper[country].length - 1;
                const bigImage = entity.alt === 'afys';
                return (
                  <MenuItem variant="entitiesListItem" key={entity.alt}>
                    <CardMedia
                      component="img"
                      image={getCdnUrl(entity.src)}
                      alt={entity.alt}
                      style={entitiesImagesListItem(bigImage, isLastImage)}
                    />
                  </MenuItem>
                );
              })}
            </MenuList>
          </Marquee>
        </Stack>
      </Stack>
    </Stack>
  );
}

export default Hero;
